import React from 'react';

import axios from 'axios';
import { Col, Drawer, Input, Row, List, Select, Button, message } from 'antd';

import debounce from 'debounce';

import nations from '../../../modules/nations';

import { _getOneMapApi, _getSearchCompanyRecords } from '../../../services';

import './index.css';

// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();

const Option = Select.Option;

class AddAddressDrawer extends React.Component{

	render(){

		if( !this.props.user ){
			return null;
		}

		return (
			<Drawer	
				title={`Add Address ${this.props.user.local.email}`}
				width={500}
				maskClosable={false}
				onClose={ this.props.onClose }
				visible={ this.props.drawerOpened }
			>

				<Row className={"form-row"} gutter={16}>
					<Col span={12}>
						<Input
							onChange={ ( e ) => this.handleOnChangeGenericState( 'name', e.target.value ) }
							value={this.state.address.name}
							placeholder="Contact Person Name"/>
					</Col>
					<Col span={12}>
						<Input
							onChange={ ( e ) => this.handleOnChangeGenericState( 'hp', e.target.value ) }
							value={this.state.address.hp}
							placeholder="Contact Person HP"/>
					</Col>
				</Row>
				
				
				<div ref={(node) => this.node = node}>
					<Row className={"form-row"}>
					
						<Col>						
							<Input 
								value={ this.state.address.companyName }
								onChange={ this.handleOnChangeCompanyName } 
								
								placeholder="Company Name"/>
							{
								this.state.registeredCompanies.length > 0 && (
									<List style={{ 
											width: 400,
											top: 33,
											position: "absolute"
										}}
										
										className="search-dropdown"
										size="small"
										dataSource={this.state.registeredCompanies}
										renderItem={ item => (
												<List.Item 
													onClick={ () => this.handleOnSelectCompany( item ) }>
													{item.companyName}
												</List.Item>
										)} 
										/>
								)
							}
						</Col>
					</Row>
				</div>

				<Row className={"form-row"}>
					<Col>
						<Select
							showSearch
							filterOption={(input, option) =>
								option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
							  }
							onChange={ ( value ) => this.handleOnChangeGenericState( 'country', value ) }
							value={this.state.address.country}
							style={{ width:"100%" }} >

							{nations.map(
								nation => (
									<Option value={nation.code}>
										{nation.name}
									</Option>
								)
							)}
						</Select>
					</Col>
				</Row>

				<Row className={"form-row"} gutter={16}>
					<Col span={12}>
						<Input 
							onChange={ this.handleOnChangePostalCode }
							value={ this.state.address.postalCode } 
							placeholder="Postal Code"/>
					</Col>
					<Col span={12}>
						<Input 
							onChange={ ( e ) => this.handleOnChangeGenericState( 'unit', e.target.value ) }
							value={ this.state.address.unit } 
							placeholder="Unit"/>
					</Col>
				</Row>

				<Row className={"form-row"}>
					<Col>
						<Input 
							onChange={ ( e ) => this.handleOnChangeGenericState( 'address', e.target.value ) }
							value={ this.state.address.address } 
							placeholder="Address"/>
					</Col>
				</Row>
				
				<Row className="form-row">
					<Col>
						<Button type="primary" onClick={ this.handleOnClickAddAddress }>
							Add Address
						</Button>
					</Col>
				</Row>

			</Drawer>
		)
	}

	constructor(props) {
    super(props);

    this.state = {
    	
      searchTerm: "",

      users: [],

      registeredCompanies: [],

      address: {
				address: "",
				hp: "",
				unit: "",
				country: "SG",
				name: "",
				postalCode: "",
				companyName: "",

				building: ""
      }

		};
		
		// areaCode: String,
    // address:String,
    // building:String,
    // country:String,
    // email:String,
    // hp:String,
    // name:String,
    // postalCode:String,
    // unit:String,
    // companyName: String

		this.httpFetching = false;
		this.cancelToken = axios.CancelToken.source();

		this.doCompanyNameSearch = debounce(this.doCompanyNameSearch, 150);
		this.doPostalCodeSearch = debounce(this.doPostalCodeSearch, 300);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClick);
	}
	
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClick);
	}
	
	doCompanyNameSearch = ( searchTerm ) => {

		if (!searchTerm) return;
		// if ( ! )

		this.httpFetching = true;

		_getSearchCompanyRecords( searchTerm.trim(), { cancelToken: this.cancelToken.token } )
			.then(res => {
				this.httpFetching = false;
				this.setState({ registeredCompanies: res.data });
			})
			.catch(( thrown ) => {

				if (axios.isCancel(thrown)) {
					this.httpFetching = false;	
					this.cancelToken = axios.CancelToken.source();
				}

				this.setState({ registeredCompanies: [] })
			})
	}

	doPostalCodeSearch = ( postalCode ) => {

		_getOneMapApi( postalCode )
			.then(res => {
				this.setState({ 
					address: {
						...this.state.address,
						address: res.data.results[0].ADDRESS,
						unit: ""
					} 
				});
			});

	}
	
	handleOnChangeCompanyName = ( e ) => {

		if( this.httpFetching ){
			this.cancelToken.cancel();
		}

		this.setState({
			address: {
				...this.state.address,
				companyName: e.target.value
			}
		});

		this.doCompanyNameSearch( e.target.value );
	}
	
	handleOnChangeGenericState = ( name, value ) => {
		
		this.setState({
			address: {
				...this.state.address,
				[name]: value
			}
		});
		
	}

	handleOnChangePostalCode = ( e ) => {

		this.setState({
			address: {
				...this.state.address,
				postalCode: e.target.value,
				address: "loading..."
			}
		});

		this.doPostalCodeSearch( e.target.value );

	}
	
	handleOnClickAddAddress = () => {
		
		// validate
		const { address } = this.state;
		
		let errorFlag = false;
		
		message.destroy();
		
		if( !address.name ){
			message.error("Name is required!");
			errorFlag = true;
		}
		
		if( !address.hp ){
			message.error("Contact Number is required!");
			errorFlag = true;
		}

		if( !address.postalCode ){
			message.error("Postal Code is required!");
			errorFlag = true;
		}
		
		if( !address.address ){
			message.error("Address is required!");
			errorFlag = true;
		}
		
		if( address.postalCode && address.postalCode.length !== 6 ){
			message.error("Postal Codes are 6 digits long!");
			errorFlag = true;
		}
		
		if( errorFlag ){
			return;
		}
		
		this.props.handleAddAddress( address );
		
	}

	handleOnSelectCompany = ( companyRecord ) => {
		
		this.setState({

			registeredCompanies:[],

			address:{
				...this.state.address,
				companyName: "loading...",
				postalCode: "loading...",
				unit: "loading...",
				address: "loading..."
			}
		}, () => {

			setTimeout(() => {

				let address = {
					...this.state.address,
					companyName: companyRecord.companyName,
					postalCode: companyRecord.postalCode,
					unit: companyRecord.unit,
					address: companyRecord.address
				};

				if( companyRecord.unit === "false" ){
					address.unit = "";
				}
				
				this.setState({

					registeredCompanies:[],
					address

				});

			}, 300);

		});

	} 

	handleClick = (event) => {
		if (!this.node.contains(event.target)){
			this.setState({
				registeredCompanies: []
			})
		}
	}

}

export default AddAddressDrawer;


// WEBPACK FOOTER //
// ./src/components/user/add-address-drawer/index.js